// extracted by mini-css-extract-plugin
export default {"shell":"NotificationHubPage_shell__EGPcZ"};